import React from 'react';
import PropTypes from 'prop-types';
import { Radio as MuiRadio, makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  root: (props) => ({
    color: props.borderColor,
    '& svg': {
      width: props.size,
      height: props.size,
    },
  }),
  checked: (props) => ({ color: props.checkedColor }),
});

const StyledRadio = ({ borderColor, checkedColor, size = 28, ...props }) => {
  const classes = useStyles({ borderColor, checkedColor, size });
  return <MuiRadio classes={classes} color={checkedColor ? 'default' : 'primary'} {...props} />;
};

const Radio = ({ color, borderColor, checkedColor, checked, size, ...props }) => {
  return (
    <StyledRadio
      borderColor={borderColor || color}
      checkedColor={checkedColor || color}
      checked={checked}
      size={size}
      {...props}
    />
  );
};

StyledRadio.propTypes = {
  borderColor: PropTypes.string,
  checkedColor: PropTypes.string,
  size: PropTypes.number,
};

Radio.propTypes = {
  color: PropTypes.string,
  borderColor: PropTypes.string,
  checkedColor: PropTypes.string,
  size: PropTypes.number,
  checked: PropTypes.bool,
};

export default Radio;
